import PageLayout from "components/PageLayout"

import usePurchasePlanTable from "pages/purchase-plans/hooks/usePurchasePlanTable"
import { useAppDispatch, useAppSelector } from "reducers/store"

import styled from "styled-components"
import { useNavigate } from "react-router-dom"
import { changeModalState } from "reducers/modal/modal-actions"
import { useQueryState } from "context/queryState"
import ApiPurchasePlans from "api/ApiPurchasePlans"
import { PURCHASE_PLAN } from "reducers/purchasePlan/purchase-plan-actions"
import PurchasePlanList from "./components/v2/PurchasePlanList"
import UnpublishPlanModal from "./components/v2/modal/UnpublishPlanModal"
import { useCallback, useEffect, useState } from "react"
import { showToast } from "reducers/toast/toast-actions"
import usePurchasePlanRequest from "./hooks/usePurchasePlanRequest"

const ContentContainer = styled.div`
  width: 100%;
`

const PurchasePlan = () => {
  const [selectedProduct, setSelectedProduct] = useState("")

  useQueryState(
    [PURCHASE_PLAN, selectedProduct],
    async () => await new ApiPurchasePlans().getPurchasePlans(selectedProduct),
    PURCHASE_PLAN,
    {
      refetchOnMount: "always"
    }
  )

  const { data, loading } = useAppSelector((state) => state.purchasePlan.purchasePlanList)

  const { rowData, handleOnClickRow } = usePurchasePlanTable()

  const appDispatch = useAppDispatch()

  const navigate = useNavigate()

  const [shouldSubmit, setShouldSubmit] = useState(false)

  const onSuccess = useCallback(() => {
    appDispatch(showToast("Plano republicado com sucesso!"))
  }, [])

  const { onSubmit } = usePurchasePlanRequest(
    "updatePublished",
    { _id: rowData._id, name: rowData.name } as App.PurchasePlan,
    onSuccess,
    "Erro ao republicar plano"
  )

  useEffect(() => {
    if (shouldSubmit && !rowData.isPublished) {
      onSubmit()
      setShouldSubmit(false)
    }
  }, [rowData, shouldSubmit, onSubmit])

  const onClickEdit = useCallback((item: App.IPurchasePlan) => {
    navigate(`/purchase-plans/update/${item._id}`)
  }, [])

  const onClickSwitch = useCallback((item: App.IPurchasePlan) => {
    handleOnClickRow(item)
    if (item.isPublished) {
      appDispatch(changeModalState(true, "unpublish"))

      return
    }
    setShouldSubmit(true)
  }, [])

  const navigateToCreateStep = useCallback(() => {
    navigate("/purchase-plans/create")
  }, [])

  const cardLabel = !selectedProduct
    ? "Você ainda não criou nenhum plano"
    : "Você ainda não criou nenhum plano para esse produto"

  return (
    <>
      <PageLayout
        title="Planos"
        isInitialPage={data?.length === 0}
        buttonLabel="Criar Planos"
        cardLabel={cardLabel}
        onButtonClick={navigateToCreateStep}
        isLoading={loading}
        hasTitleButton={data?.length > 0}
        handleSelectChange={setSelectedProduct}
        selectedProduct={selectedProduct}
        hasFilters
      >
        <ContentContainer>
          <PurchasePlanList onClickEdit={onClickEdit} onClickSwitch={onClickSwitch} />
        </ContentContainer>
      </PageLayout>

      <UnpublishPlanModal planData={{ _id: rowData._id, name: rowData.name } as App.PurchasePlan} />
    </>
  )
}

export default PurchasePlan
